import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

import { determineJournalUrl } from './journal-type.widget.model';

export interface ExtPersonalCoachingItem {
    name: string;
    metricName: string;
    pctGoal: number;
    pctTarget: number;
    goalMet: number;
    journalID: number;
    journalTypeID: number;
    daysOld: number;
}

export interface PersonalCoachingItem {
    name: string;
    metricName: string;
    pctGoal: number;
    pctTarget: number;
    goalMet: boolean;
    isOld: boolean;
    journalUrl: string;
}

export interface PersonalCoaching {
    items: PersonalCoachingItem[];
}

class PersonalCoachingItemModelTransformer
    implements ModelTransformer<PersonalCoachingItem, ExtPersonalCoachingItem>
{
    transform(model: ExtPersonalCoachingItem): PersonalCoachingItem {
        return {
            name: model.name,
            metricName: model.metricName,
            pctGoal: model.pctGoal,
            pctTarget: model.pctTarget,
            goalMet: model.goalMet != null && model.goalMet !== 0,
            isOld: model.daysOld > 30, // TODO revise
            journalUrl: determineJournalUrl(
                model.journalTypeID,
                model.journalID,
            ),
        };
    }
}

class PersonalCoachingItemModelSetTransformer extends ModelSetTransformer<
    PersonalCoachingItem,
    ExtPersonalCoachingItem
> {
    protected newTransformer(): ModelTransformer<
        PersonalCoachingItem,
        ExtPersonalCoachingItem
    > {
        return new PersonalCoachingItemModelTransformer();
    }
}

export class PersonalCoachingModelTransformer
    implements ModelTransformer<PersonalCoaching, ExtPersonalCoachingItem[]>
{
    transform(model: ExtPersonalCoachingItem[]): PersonalCoaching {
        const items = new PersonalCoachingItemModelSetTransformer().transform(
            model,
        );
        return {
            items,
        };
    }
}

export function validatePersonalCoaching(model: PersonalCoaching): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const valid =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model != null && model.items != null && model.items.length !== 0;
    if (!valid) {
        throw new Error('PersonalCoaching not valid');
    }
}
